module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Heimenhausen_COA-55f0d5fb82e7115bc7378729bc19c108.svg";